/* eslint-disable import/no-named-as-default */
import React from 'react'
import Logo from './Logo'
import TopNav from './TopNav'
import Search from '../../search'
import HamburgerMenu from './HamburgerMenu'
import './header.scss'

const Header = ({ ...props }) => (
  <div className="header-wrapper">
    <HamburgerMenu />
    <Logo {...props} />
    <Search {...props} />
    <TopNav />
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./components/header/asda-com/index.js